// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinnerCenter_spinner__q6mq2"};